import classNames from "classnames";
import React, { ButtonHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";

import style from "./RemoveAction.module.scss";

export interface RemoveActionProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const RemoveAction: React.FC<RemoveActionProps> = ({ className, ...buttonProps }) => (
  <button {...buttonProps} type="button" className={classNames(style.removeButton, className)}>
    <FormattedMessage id="actions.remove" />
  </button>
);
